import gql from "graphql-tag";

export const deleteOrganization = gql`
  mutation DeleteOrganization($input: DeleteOrganizationRequestInput) {
    DeleteOrganization(input: $input) {
      deleted
    }
  }
`;
